import { useStore } from '@nanostores/react'
import { StackIcon } from 'shared/ui'

import { $reply } from '../MessageActions/MessageActions'
import css from './ReplyPreview.module.css'

export function ReplyPreview() {
	const reply = useStore($reply)

	if (reply === null) {
		return null
	}

	return (
		<div className={css.root}>
			<h5 className={css.title}>{`Reply to ${reply.from?.firstName}`}</h5>

			<p className={css.text}>{reply.text}</p>

			<button
				aria-label='Cancel reply'
				className={css.close}
				onClick={() => $reply.set(null)}
			>
				<StackIcon
					icon='close'
					stroke='currentcolor'
					strokeWidth={2}
					width={8}
				/>
			</button>
		</div>
	)
}
